// Where a host script (popover.js, embed.js) was served from: the play shell
// and Pixie come from the same host.

const PLAY_ORIGIN = "https://play.pixmoto.com";

/** The http(s) origin of a script URL, or null. */
export function httpOrigin(src: string): string | null {
  try {
    const url = new URL(src, window.location.href);
    return url.protocol === "https:" || url.protocol === "http:"
      ? url.origin
      : null;
  } catch {
    return null;
  }
}

/**
 * The origin of the running host script. `current` is `document.currentScript`
 * read while the script first runs; it is null later, in callbacks. Other
 * scripts can share the file name (Bootstrap 3 ships a `js/popover.js`), so
 * the first tag named like `ownSrc` is used only when `current` was not set
 * (code run from a shadow root or through `eval`). A `current` named
 * otherwise (a copy the site renamed or bundled) gets the default play host.
 */
export function hostScriptOrigin(
  current: Element | null,
  ownSrc: RegExp,
): string {
  if (current) {
    const src = current instanceof HTMLScriptElement ? current.src : "";
    return (src && ownSrc.test(src) && httpOrigin(src)) || PLAY_ORIGIN;
  }
  const scripts = document.getElementsByTagName("script");
  for (let i = 0; i < scripts.length; i++) {
    const src = scripts[i].src;
    const origin = src && ownSrc.test(src) ? httpOrigin(src) : null;
    if (origin) {
      return origin;
    }
  }
  return PLAY_ORIGIN;
}
